import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import Menu from '../menu/Menu';
import Header from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Titulo from '../titulo/Titulo';
import AranjosService from '../../service/arranjos/AranjosService';
import UsuariosService from '../../service/usuario';

// ─── Configuração dos arranjos ────────────────────────────────────────────────
const ARRANJOS = [
  {
    tipo: 'manutencao-carrinhos',
    label: 'Manutenção dos Carrinhos',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="2"/>
        <path d="M16 8h6M19 5v6"/>
      </svg>
    ),
  },
  {
    tipo: 'eventos',
    label: 'Eventos',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
  },
  {
    tipo: 'aeroporto',
    label: 'Aeroporto',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 00-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
      </svg>
    ),
  },
];

// ─── Styled Components ────────────────────────────────────────────────────────
const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px;
  margin-bottom: 50px;
`;

const Container = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 260px;
  padding: 20px 32px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    margin-left: 60px;
    padding: 20px;
  }
  @media (max-width: 767px) {
    margin-left: 0;
    padding: 16px;
  }
`;

const TabsRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const TabBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: 8px;
  border: 2px solid ${(p) => (p.$active ? '#008080' : '#b2d8d8')};
  background: ${(p) => (p.$active ? '#008080' : 'white')};
  color: ${(p) => (p.$active ? 'white' : '#008080')};
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  svg { stroke: ${(p) => (p.$active ? 'white' : '#008080')}; }
  &:hover { background: ${(p) => (p.$active ? '#006666' : '#e0f2f1')}; }
`;

const Card = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f0f0;
`;

const CardTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    display: block;
    width: 4px;
    height: 20px;
    background: #008080;
    border-radius: 2px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 24px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
`;

const Tr = styled.tr`
  &:not(:last-child) { border-bottom: 1px solid #f5f5f5; }
  &:hover { background: #fafafa; }
`;

const Td = styled.td`
  padding: 14px 24px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
`;

const Avatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #008080;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
`;

const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PrincipalBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff8e1;
  color: #f59e0b;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
`;

const ActionBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  color: ${(p) => (p.$danger ? '#dc2626' : '#008080')};
  transition: background 0.15s;

  &:hover { background: ${(p) => (p.$danger ? '#fee2e2' : '#e0f2f1')}; }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
`;

const EmptyRow = styled.tr`
  td {
    text-align: center;
    color: #aaa;
    padding: 32px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
  }
`;

const AddSection = styled.div`
  padding: 18px 24px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

const SearchInput = styled.input`
  width: 100%;
  border: 1.5px solid #d0d0d0;
  border-radius: 8px;
  padding: 9px 14px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #222;
  outline: none;
  box-sizing: border-box;
  background: white;

  &:focus { border-color: #008080; }
  &::placeholder { color: #bbb; }
`;

const Suggestions = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  bottom: auto;
  left: 0;
  right: 0;
  background: white;
  border: 1.5px solid #d0d0d0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  padding: 4px 0;
  list-style: none;
`;

const SuggestionItem = styled.li`
  padding: 9px 14px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #333;
  cursor: pointer;

  &:hover { background: #e0f2f1; }
`;

const BtnAdd = styled.button`
  background: #008080;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover { background: #006666; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const Toast = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: ${(p) => (p.$tipo === 'error' ? '#dc2626' : '#388e3c')};
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 9999;
  min-width: 260px;
  text-align: center;
`;

// ─── Helpers ──────────────────────────────────────────────────────────────────
function getInitials(nome) {
  if (!nome) return '?';
  const p = nome.trim().split(' ');
  return p.length >= 2
    ? (p[0][0] + p[p.length - 1][0]).toUpperCase()
    : p[0].substring(0, 2).toUpperCase();
}

// ─── Componente ───────────────────────────────────────────────────────────────
export default function GerenciarArranjos() {
  const [abaAtiva, setAbaAtiva] = useState('manutencao-carrinhos');
  const [responsaveis, setResponsaveis] = useState({
    'manutencao-carrinhos': [],
    'eventos': [],
    'aeroporto': [],
  });
  const [carregando, setCarregando] = useState(false);

  // Busca de usuários
  const [todosUsuarios, setTodosUsuarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [sugestoesVisiveis, setSugestoesVisiveis] = useState(false);
  const [adicionando, setAdicionando] = useState(false);

  const [toast, setToast] = useState({ visivel: false, mensagem: '', tipo: 'success' });

  const mostrarToast = (mensagem, tipo = 'success') => {
    setToast({ visivel: true, mensagem, tipo });
    setTimeout(() => setToast((t) => ({ ...t, visivel: false })), 3000);
  };

  // Carregar todos os usuários uma vez
  useEffect(() => {
    UsuariosService.getUsuarios()
      .then((data) => setTodosUsuarios(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const carregarAba = useCallback(async (tipo) => {
    setCarregando(true);
    try {
      const lista = await AranjosService.listarResponsaveis(tipo);
      setResponsaveis((prev) => ({ ...prev, [tipo]: lista }));
    } catch {
      mostrarToast('Erro ao carregar responsáveis.', 'error');
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    carregarAba(abaAtiva);
  }, [abaAtiva, carregarAba]);

  // Filtrar sugestões
  const sugestoes = busca.trim().length >= 2
    ? todosUsuarios
        .filter((u) => u.nome?.toLowerCase().includes(busca.toLowerCase()))
        .slice(0, 8)
    : [];

  const handleSelecionarUsuario = (usuario) => {
    setUsuarioSelecionado(usuario);
    setBusca(usuario.nome);
    setSugestoesVisiveis(false);
  };

  const handleAdicionar = async () => {
    if (!usuarioSelecionado) return;
    setAdicionando(true);
    try {
      await AranjosService.adicionarResponsavel(abaAtiva, usuarioSelecionado._id);
      await carregarAba(abaAtiva);
      setBusca('');
      setUsuarioSelecionado(null);
      mostrarToast('Responsável adicionado com sucesso!');
    } catch (e) {
      mostrarToast(e?.response?.data?.erro || 'Erro ao adicionar responsável.', 'error');
    } finally {
      setAdicionando(false);
    }
  };

  const handleDefinirPrincipal = async (id) => {
    try {
      await AranjosService.definirPrincipal(abaAtiva, id);
      await carregarAba(abaAtiva);
      mostrarToast('Encarregado principal definido!');
    } catch (e) {
      mostrarToast(e?.response?.data?.erro || 'Erro ao definir principal.', 'error');
    }
  };

  const handleRemover = async (id) => {
    try {
      await AranjosService.removerResponsavel(abaAtiva, id);
      await carregarAba(abaAtiva);
      mostrarToast('Responsável removido.');
    } catch (e) {
      mostrarToast(e?.response?.data?.erro || 'Erro ao remover.', 'error');
    }
  };

  const arranjoAtivo = ARRANJOS.find((a) => a.tipo === abaAtiva);
  const lista = responsaveis[abaAtiva] || [];

  return (
    <PageWrapper>
      <Header />
      <MainContentWrapper>
        <Menu />
        <Container>
          <Titulo>Gerenciar Arranjos</Titulo>
          <p style={{ fontFamily: "'Roboto', sans-serif", fontSize: 13, color: '#8e8e93', margin: '0 0 20px 0' }}>
            Gerencie os responsáveis e o encarregado principal de cada arranjo.
          </p>

          {/* Abas */}
          <TabsRow>
            {ARRANJOS.map((a) => (
              <TabBtn
                key={a.tipo}
                $active={abaAtiva === a.tipo}
                onClick={() => { setAbaAtiva(a.tipo); setBusca(''); setUsuarioSelecionado(null); }}
              >
                {a.icon}
                {a.label}
              </TabBtn>
            ))}
          </TabsRow>

          {/* Card do arranjo ativo */}
          <Card>
            <CardHeader>
              <CardTitle>{arranjoAtivo?.icon} {arranjoAtivo?.label}</CardTitle>
              <span style={{ fontFamily: "'Roboto', sans-serif", fontSize: 13, color: '#aaa' }}>
                {lista.length} responsável(is)
              </span>
            </CardHeader>

            {/* Adicionar responsável */}
            <AddSection>
              <SearchWrapper>
                <SearchInput
                  placeholder="Buscar publicador pelo nome..."
                  value={busca}
                  onChange={(e) => {
                    setBusca(e.target.value);
                    setUsuarioSelecionado(null);
                    setSugestoesVisiveis(true);
                  }}
                  onFocus={() => setSugestoesVisiveis(true)}
                  onBlur={() => setTimeout(() => setSugestoesVisiveis(false), 150)}
                />
                {sugestoesVisiveis && sugestoes.length > 0 && (
                  <Suggestions>
                    {sugestoes.map((u) => (
                      <SuggestionItem key={u._id} onMouseDown={() => handleSelecionarUsuario(u)}>
                        {u.nome}
                      </SuggestionItem>
                    ))}
                  </Suggestions>
                )}
              </SearchWrapper>
              <BtnAdd onClick={handleAdicionar} disabled={!usuarioSelecionado || adicionando}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                {adicionando ? 'Adicionando...' : 'Adicionar Responsável'}
              </BtnAdd>
            </AddSection>

            <Table>
              <thead>
                <tr>
                  <Th>Responsável</Th>
                  <Th>Função</Th>
                  <Th style={{ textAlign: 'right' }}>Ações</Th>
                </tr>
              </thead>
              <tbody>
                {carregando ? (
                  <EmptyRow><td colSpan={3}>Carregando...</td></EmptyRow>
                ) : lista.length === 0 ? (
                  <EmptyRow><td colSpan={3}>Nenhum responsável cadastrado para este arranjo.</td></EmptyRow>
                ) : (
                  lista.map((r) => (
                    <Tr key={r._id}>
                      <Td>
                        <UserCell>
                          <Avatar>{getInitials(r.usuario?.nome)}</Avatar>
                          <div>
                            <div style={{ fontWeight: 500 }}>{r.usuario?.nome}</div>
                            <div style={{ fontSize: 12, color: '#aaa' }}>{r.usuario?.email}</div>
                          </div>
                        </UserCell>
                      </Td>
                      <Td>
                        {r.principal ? (
                          <PrincipalBadge>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="#f59e0b" stroke="none">
                              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                            </svg>
                            Encarregado Principal
                          </PrincipalBadge>
                        ) : (
                          <span style={{ color: '#aaa', fontSize: 13 }}>Responsável</span>
                        )}
                      </Td>
                      <Td style={{ textAlign: 'right' }}>
                        {!r.principal && (
                          <ActionBtn
                            title="Definir como encarregado principal"
                            onClick={() => handleDefinirPrincipal(r._id)}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                            </svg>
                          </ActionBtn>
                        )}
                        <ActionBtn
                          $danger
                          title="Remover responsável"
                          onClick={() => handleRemover(r._id)}
                          disabled={r.principal}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                          </svg>
                        </ActionBtn>
                      </Td>
                    </Tr>
                  ))
                )}
              </tbody>
            </Table>
          </Card>
        </Container>
      </MainContentWrapper>
      <Rodape />

      {toast.visivel && <Toast $tipo={toast.tipo}>{toast.mensagem}</Toast>}
    </PageWrapper>
  );
}
